import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  Button,
  Col,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap';
import { cleanData } from 'redux-store/actions/index';
import { API, BASE_URL, SEARCH_DELAY_MS } from 'CONST';
import auth from 'helpers/auth';
import AsyncSelect from 'react-select/async';
import BaseModal from './UI/BaseModal';

function mapDispatchToProps(dispatch) {
  return {
    resetData: client => dispatch(cleanData(client)),
  };
}

class CreateClientLine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client: undefined,
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleError = this.handleError.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
    this.filterOption = this.filterOption.bind(this);
    this.filterOptionsWithDebounce = _.debounce(
      this.filterOption,
      SEARCH_DELAY_MS,
    );
  }

  filterOption = (inputValue, resolve) => {
    const url = `${BASE_URL}${API.clientes}?roles__term=afianzadogarantia${inputValue.length > 0 ? `&search=${inputValue}` : ''}`;
    return auth.fetch(url)
      .then(data => {
        const options = data.results.map(node => ({
          label: `${node.rut} - ${node.nombre}`,
          value: node,
        }));
        resolve(options);
      })
  };

  loadOptions = inputValue =>
    new Promise(resolve =>
      this.filterOptionsWithDebounce(inputValue, resolve)
    );

  handleChange(client) {
    const { resetData } = this.props;
    resetData();
    this.setState({ client })
  }

  isDisabled() {
    const { client } = this.state;
    return (client === undefined || client === '');
  }

  handleCreate(e) {
    e.preventDefault();
    const { handleSubmit } = this.props;
    const { client } = this.state;
    this.setState({ loading: true });
    const config = { organizacion_id:  client.value.id };
    handleSubmit(config, () => this.setState({ loading: false }));
  }

  handleError() {
    const { error } = this.props;
    return error[0] || 'Ha ocurrido un error';
  }

  render() {
    const {
      error,
      handleModal,
      modalOpen,
    } = this.props;
    const { client, loading } = this.state;
    return (
      <BaseModal
        handleModal={handleModal}
        modalOpen={modalOpen}
        type="create-line"
      >
        <ModalHeader toggle={handleModal}>
          Crear línea para cliente
        </ModalHeader>
        <div className="body">
          <Row className="body-text">
            <Col md="3" className="label secondary">
              Seleccionar cliente
            </Col>
            <Col>
              <AsyncSelect
                cacheOptions
                defaultOptions
                id="client"
                isClearable
                loadOptions={this.loadOptions}
                name="client"
                onChange={this.handleChange}
                placeholder="Seleccione Beneficiario"
              />
              {(error !== null && error && client) && (
                <span className="text-danger error">
                  {this.handleError()}
                </span>
              )}
            </Col>
          </Row>
        </div>
        <ModalFooter className="text-right">
          <Button
            className="token-accept"
            disabled={this.isDisabled() || loading}
            onClick={this.handleCreate}
          >
            Crear Línea
          </Button>
        </ModalFooter>
      </BaseModal>
    );
  }
}

const mapStateToProps = state => ({
  clients: state.clients.clientList,
  error: state.clients.errorMessages,
  success: state.clients.successMessage,
});

CreateClientLine.propTypes = {
  clients: PropTypes.shape({
    count: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.object),
    next: PropTypes.string,
    pages: PropTypes.number,
    previous: PropTypes.string,
  }).isRequired,
  error: PropTypes.string,
  handleModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  resetData: PropTypes.func.isRequired,
};

CreateClientLine.defaultProps = {
  error: undefined,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateClientLine);